/* ASG Procurement theme scripts */
(function () {
  'use strict';

  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.addEventListener('click', function () { drawer.removeAttribute('open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer.removeAttribute('open'); });
    drawer.addEventListener('toggle', function () { document.body.style.overflow = drawer.open ? 'hidden' : ''; });
    drawer.querySelector('.drawer__panel').addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('click', function (e) { if (drawer.open && !drawer.contains(e.target)) drawer.removeAttribute('open'); });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('.qty__input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var val = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty'), 10);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) { if (e.target.matches('[data-autosubmit]')) filterForm.submit(); });
  }

  var product = document.querySelector('[data-product]');
  if (product) {
    var mainImg = product.querySelector('.gallery__main img');
    var setImage = function (src) { if (mainImg && src) { mainImg.removeAttribute('srcset'); mainImg.src = src; } };
    product.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        product.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        setImage(t.getAttribute('data-src'));
      });
    });

    var jsonEl = document.querySelector('[data-product-json]');
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var selects = product.querySelectorAll('[data-option-index]');
    if (data && selects.length) {
      var update = function () {
        var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        var idInput = product.querySelector('[data-variant-id]');
        var addBtn = product.querySelector('[data-add]');
        var addLabel = product.querySelector('[data-add-label]');
        var stock = product.querySelector('[data-stock]');
        var priceEl = product.querySelector('[data-price]');
        var skuWrap = product.querySelector('[data-sku]');
        if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (priceEl) priceEl.textContent = v.price;
        if (stock) {
          stock.className = 'stock ' + (v.available ? 'stock--in' : 'stock--out');
          stock.textContent = v.available ? 'In stock' : 'Out of stock';
        }
        if (skuWrap) {
          skuWrap.hidden = !v.sku;
          var sv = skuWrap.querySelector('[data-sku-value]');
          if (sv) sv.textContent = v.sku || '';
        }
        if (v.image) setImage(v.image);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      };
      selects.forEach(function (s) { s.addEventListener('change', update); });
    }
  }

  var recs = document.querySelector('[data-recs]');
  if (recs && !recs.querySelector('.pgrid')) {
    fetch(recs.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) recs.innerHTML = fresh.innerHTML;
        else recs.remove();
      })
      .catch(function () { recs.remove(); });
  }

  var quoteItems = document.querySelector('[data-quote-items]');
  if (quoteItems) {
    var p = new URLSearchParams(window.location.search).get('product');
    if (p && !quoteItems.value) quoteItems.value = p + ' — qty: ';
  }
})();
